import { IEltDocFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export const URL_VERSION_PARAMETER = 'vid'
export const GROUP_ID_VERSION_PARAMETER = 'vgp'
export const PARTNER_ID_VERSION_PARAMETER = 'vp'

export const lastMeetingDataTabNumber = 7
export const polyFinancialsTabNumber = 5
export const scoreCardTabNumber = 8
export const businessPerformanceTabDoc = 3
export const BUSINESS_PERFORMANCE_TAB_ID = getFormedEltTranslation('page-business-performance')

export const CUSTOMER_REVENUE_TOTAL = 'jbp-elt-customer-revenue-total'
export const PERFORMANCE_REVENUE_TOTAL = 'jbp-elt-v3-performance-revenue'

export const pptxCompanyAtGlance = [
  'Brief description of the company/business',
  'Ticker: XXX Market Cap: XXX',
  `HQ Location: {HQLocation}\nGlobal presence – where?`,
  '# employees {Employees}',
  'Company Revenue (in US Dollars):{Revenue}',
  `CUSTOMER: Where do they stand? Are they in their industry?\nPARTNERS: Is this Partner #1/#2 in the market?\nIs their market growing, flat, or declining?`,
  `List other newsworthy company facts, recent headlines
              - Any key Mergers/Acquisitions?
              - (as applicable)`,
]

export const docCompanyAtGlance = [
  '• Brief description of the company/business\n• What are the main reportable segments and relative sizes\n• Who are their target customers',
  'Public/Private:',
  'Ticker: XXX',
  'Market Cap: XXX',
  'HQ Location: {HQLocation}',
  'Global presence – where?',
  '# employees: {Employees}',
  'Customer – where do they stand in their industry?',
  'Partner - is partner #1/#2 in their market – is their market growing?',
]

export const tabFlagMap: Record<string, keyof IEltDocFormData> = {
  [BUSINESS_PERFORMANCE_TAB_ID]: 'IsBusinessPerformanceTabEnabled',
}

export const defaultActualValueTypes = [ActualsValueTypes.Net, ActualsValueTypes.Ndp]
export const defaultActualValueType = ActualsValueTypes.Net
export const rolesWithoutAccess = ['Partner User']
